<div class="modal-header">
    <h6 class="modal-title medium">{{'createMobileApp'|translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body advanced-mode">
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label> {{'appName'|translate}} <span class="text-danger medium">*</span></label>
            <input type="text" [(ngModel)]="mobileAppData.mobileAppName" class="form-control"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label> {{'appKey'|translate}} <span class="text-danger medium">*</span></label>
            <input type="text" [(ngModel)]="mobileAppData.mobileAppKey" class="form-control" [disabled]="isUpdate"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label> {{'androidVer'|translate}} </label>
            <input type="text" [(ngModel)]="mobileAppData.versionAndroid" class="form-control"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label> {{'iosVer'|translate}} </label>
            <input type="text" [(ngModel)]="mobileAppData.versionIos" class="form-control"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label>{{'firebaseKey'|translate}}</label>
            <input type="text" [(ngModel)]="mobileAppData.fireBaseKey" class="form-control"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label> {{'redirectUrlAndroid'|translate}}</label>
            <input type="text" [(ngModel)]="mobileAppData.redirectUrlAndroid" class="form-control"/>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group w-100">
            <label> {{'redirectUrliOS'|translate}}</label>
            <input type="text" [(ngModel)]="mobileAppData.redirectUrlIos" class="form-control"/>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary float-right" (click)="cancel()"> {{'cancelProcess'|translate}}</button>
    <button class="btn btn-primary float-right" (click)="save()"> {{'Save'|translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/superAdmin/createMobileApplication.html